// extracted by mini-css-extract-plugin
module.exports = {"demographics-chart-table":"chartTable_demographics-chart-table__UF_OV","selected":"chartTable_selected__k81S0","sortyby":"chartTable_sortyby__e2Hpt"};